export default function preventScroll () {
	const collapseBtn = document.querySelector('.collapse-button');
	const htmlElement = document.querySelector('html');
	const accordionMenu = document.querySelector('#accordion-menu');
	const iconExpandLink = document.querySelector('.nr0');
	const selectedSubMenu2 = document.querySelector('#my_pages-selected');

	if(collapseBtn) {
		// if the menu is open, prevent html element from scrolling.
		collapseBtn.addEventListener('click', function () {
			if(accordionMenu.classList.value === 'collapse') {
				htmlElement.style.overflow = 'hidden';
			}
			else {
				htmlElement.style.overflow = 'scroll';
			}
		});
	}
	
	if(selectedSubMenu2) {
		// if the menu is open, prevent html element from scrolling.
		iconExpandLink.addEventListener('click', function() {
			if(selectedSubMenu2.style.display !== 'block') {
				htmlElement.style.overflow = 'hidden';
			}
			else {
				htmlElement.style.overflow = 'scroll';
			}
		});
	}
}